import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import type { IntlShape } from "react-intl";

import { MESSAGES } from "../../../pages/banking/banking-accounts/message-definitions";
import { formatStatementDate } from "../../../pages/banking/banking-accounts/utils";

import type { StatementCoverageRange } from "./air-statement-coverage";

export const getAirStatementSubtitle = (
  intl: IntlShape,
  ranges: StatementCoverageRange[],
  { outsideRequiredPeriod = false, windowStart }: { outsideRequiredPeriod?: boolean; windowStart?: Dayjs } = {}
): string | undefined => {
  if (ranges.length === 0) {
    return undefined;
  }
  const starts = ranges.map(({ start }) => dayjs(start));
  const ends = ranges.map(({ end }) => dayjs(end));
  const earliestStart = starts.reduce((earliest, date) => (date.isBefore(earliest) ? date : earliest));
  const start = windowStart && earliestStart.isBefore(windowStart) ? windowStart : earliestStart;
  const end = ends.reduce((latest, date) => (date.isAfter(latest) ? date : latest));
  const period = start.isSame(end, "day")
    ? formatStatementDate(end, intl.locale, true)
    : intl.formatMessage(MESSAGES.statementCoverageDates, {
        startDate: formatStatementDate(start, intl.locale, start.year() !== end.year()),
        endDate: formatStatementDate(end, intl.locale, true),
      });
  return intl.formatMessage(
    outsideRequiredPeriod ? MESSAGES.statementCoversOutsidePeriodSubtitle : MESSAGES.statementCoversSubtitle,
    { period }
  );
};
